import "regenerator-runtime/runtime";
import { configureStore } from "@reduxjs/toolkit";

import createSagaMiddleware from "redux-saga";
import { createWrapper } from "next-redux-wrapper";
import { selfApi } from "@fdn/rtk_profile_store";
import { apiSlice } from "./rtk-query/feature/api/apiSlice";

import rootReducer from "./reducer";
import rootSaga from "./actions";

export const makeStore = () => {

	const sagaMiddleware = createSagaMiddleware();
	const store = configureStore({
		reducer: rootReducer,
		middleware: (getDefaultMiddleware) => getDefaultMiddleware()
			.concat(apiSlice.middleware)
			.concat(selfApi.middleware)
			.concat(sagaMiddleware),
	});

	store.sagaTask = sagaMiddleware.run(rootSaga);
	return store;

};
export const wrapper = createWrapper(makeStore, { debug: false });
